import type { ReactNode } from 'react';
import { Navigate } from 'react-router-dom';
import { useHrEmployeesGrant } from '../lib/hr-grant';

/**
 * HrGrantGuard — 「직원 관리」(`/erp/hr/employees*`) 라우트 가드 (2026-09-14).
 *
 * `RoleGuard(ADMIN·SYSTEM_ADMIN)` 에 **인사 메뉴를 명시적으로 받은 사람**을 더한 것이다 —
 * 서버(`isHrAdminOrGranted(auth, 'hr')`)가 여는 사람을 화면이 돌려보내지 않게. 판정은 `lib/hr-grant.ts`.
 *
 * - 아직 모름(로그인 확인 중 · 서버에 묻는 중) → 아무것도 그리지 않는다(깜빡임 · 오판 방지 — RoleGuard 와 같다)
 * - 못 들어감(403 · 429/5xx 미확정 · 로그인 안 함) → `/dashboard` (RoleGuard 와 같은 곳)
 *
 * ⚠ UX 게이트일 뿐이다 — 권위 있는 차단은 서버가 한다.
 */
export function HrGrantGuard({ children }: { children: ReactNode }) {
  const ok = useHrEmployeesGrant();
  if (ok === null) return null;
  if (!ok) return <Navigate to="/dashboard" replace />;
  return <>{children}</>;
}
